module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.a2ffc024e6e6fb433f32.js");
};